var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaveBackgroud(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 664,
    height: 187,
    viewBox: "0 0 664 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.0526316,
    d: "M43.1905 412.547C67.5134 444.906 145.252 499.056 261.623 456.779C407.088 403.932 463.347 263.849 593.176 191.214C688.999 137.605 946.481 57.1333 1094.54 146.055",
    stroke: "#5CF1BB",
    strokeOpacity: 0.25,
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.105263,
    d: "M19.1997 344.706C40.0069 379.431 111.659 441.41 231.812 411.529C382.004 374.176 452.597 240.742 589.308 182.076C690.21 138.776 954.692 85.6597 1092.64 189.571",
    stroke: "#5CF1BB",
    strokeOpacity: 0.25,
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.157895,
    d: "M1.07608 275.953C18.1395 312.663 82.921 381.792 205.539 364.634C358.812 343.185 442.967 217.861 585.06 173.806C689.936 141.291 958.522 116.111 1084.85 233.873",
    stroke: "#5CF1BB",
    strokeOpacity: 0.25,
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.210526,
    d: "M-11.125 206.902C2.0078 245.194 59.2084 320.716 182.949 316.469C337.624 311.159 434.417 195.318 580.337 166.358C688.037 144.983 957.784 148.016 1071.11 278.338",
    stroke: "#5CF1BB",
    strokeOpacity: 0.25,
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.263158,
    d: "M-17.3886 138.176C-8.33032 177.631 40.6628 258.719 164.169 267.429C318.552 278.316 426.924 173.227 575.072 159.678C684.416 149.678 952.368 180.891 1051.46 322.345",
    stroke: "#5CF1BB",
    strokeOpacity: 0.25,
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.315789,
    d: "M-17.7935 70.3919C-12.909 110.578 27.3397 196.342 149.259 217.914C301.658 244.88 420.421 151.694 569.174 153.705C678.964 155.19 942.185 214.24 1025.94 365.277",
    stroke: "#5CF1BB",
    strokeOpacity: 0.25,
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.368421,
    d: "M-12.4639 4.15785C-11.8068 44.634 19.2566 134.136 138.253 168.334C286.999 211.082 414.852 130.821 562.579 148.37C671.613 161.322 927.22 247.563 994.733 406.528",
    stroke: "#5CF1BB",
    strokeOpacity: 0.25,
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.421053,
    d: "M-1.5997 -59.9347C-5.17705 -19.6116 16.3607 72.6469 131.131 119.096C274.593 177.158 410.135 110.701 555.219 143.595C662.302 167.874 907.494 280.361 958.02 445.511",
    stroke: "#5CF1BB",
    strokeOpacity: 0.25,
    strokeWidth: 3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.473684,
    d: "M14.549 -121.32C6.77628 -81.5913 18.5524 12.4131 127.838 70.6047C264.446 143.344 406.192 91.4194 547.043 139.299C651.001 174.638 883.092 312.138 916.078 481.665",
    stroke: "#5CF1BB",
    strokeOpacity: 0.25,
    strokeWidth: 3
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.526316,
    d: "M35.6746 -179.46C23.7917 -140.762 25.6772 -46.0414 128.282 23.2549C256.537 109.875 402.935 73.0515 538.009 135.392C637.704 181.403 854.151 342.41 869.236 514.457",
    stroke: "#5CF1BB",
    strokeOpacity: 0.25,
    strokeWidth: 3
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.578947,
    d: "M61.3982 -233.854C45.5354 -196.61 37.5096 -102.212 132.309 -22.5699C250.807 76.9823 400.252 55.663 528.07 131.781C622.409 187.961 820.84 370.711 817.859 543.392",
    stroke: "#5CF1BB",
    strokeOpacity: 0.25,
    strokeWidth: 3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.631579,
    d: "M91.3172 -284.038C71.6483 -248.656 53.7991 -155.613 139.754 -66.4986C247.198 44.8947 398.052 39.3134 517.213 128.375C605.163 194.109 783.405 396.599 762.39 568.023",
    stroke: "#5CF1BB",
    strokeOpacity: 0.25,
    strokeWidth: 3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.684211,
    d: "M124.96 -329.599C101.7 -296.467 74.2234 -205.8 150.392 -108.189C245.604 13.8252 396.215 24.043 505.414 125.072C586.011 199.639 742.11 419.652 703.292 587.94",
    stroke: "#5CF1BB",
    strokeOpacity: 0.25,
    strokeWidth: 3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.736842,
    d: "M161.825 -370.174C135.23 -339.655 98.4262 -252.356 163.975 -147.318C245.91 -16.0201 394.629 9.88496 492.669 121.775C565.03 204.359 697.277 439.483 641.08 602.791",
    stroke: "#5CF1BB",
    strokeOpacity: 0.25,
    strokeWidth: 3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.789474,
    d: "M201.376 -405.452C171.736 -377.88 126.009 -294.907 180.219 -183.592C247.981 -44.449 393.177 -3.14059 478.985 118.385C542.317 208.079 649.262 455.739 576.303 612.279",
    stroke: "#5CF1BB",
    strokeOpacity: 0.25,
    strokeWidth: 3
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.842105,
    d: "M243.039 -435.183C210.68 -410.86 156.53 -333.121 198.807 -216.75C251.654 -71.2855 391.737 -15.0263 464.371 114.803C517.981 210.626 598.453 468.108 509.531 616.164",
    stroke: "#5CF1BB",
    strokeOpacity: 0.25,
    strokeWidth: 3
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.894737,
    d: "M286.223 -459.173C251.499 -438.366 189.519 -366.714 219.401 -246.561C256.753 -96.3693 390.188 -25.7756 448.854 110.934C492.154 211.837 545.27 476.319 441.359 614.269",
    stroke: "#5CF1BB",
    strokeOpacity: 0.25,
    strokeWidth: 3
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.947368,
    d: "M330.325 -477.297C293.615 -460.234 224.486 -395.452 241.645 -272.834C263.093 -119.561 388.417 -35.4062 432.472 106.687C464.987 211.563 490.167 480.149 372.406 606.481",
    stroke: "#5CF1BB",
    strokeOpacity: 0.25,
    strokeWidth: 3
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M374.723 -489.492C336.431 -476.359 260.909 -419.159 265.156 -295.419C270.466 -140.743 386.307 -43.9498 415.267 101.97C436.642 209.67 433.609 479.417 303.287 592.748",
    stroke: "#5CF1BB",
    strokeOpacity: 0.25,
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveBackgroud);
export default __webpack_public_path__ + "static/media/WaveBackgroud.f5ee06f9fe1d49f45cbd77ab05880a7d.svg";
export { ForwardRef as ReactComponent };